/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IToysrusLanguageSelectorData } from './toysrus-language-selector.data';
import { IToysrusLanguageSelectorProps } from './toysrus-language-selector.props.autogenerated';

export interface IToysrusLanguageSelectorViewProps
  extends IToysrusLanguageSelectorProps<IToysrusLanguageSelectorData> {
  languageSwitcher: React.ReactNode;
}

/**
 *
 * ToysrusLanguageSelector component
 * @extends {React.PureComponent<IToysrusLanguageSelectorProps<IToysrusLanguageSelectorData>>}
 */
class ToysrusLanguageSelector extends React.PureComponent<
  IToysrusLanguageSelectorProps<IToysrusLanguageSelectorData>
> {
  public render(): JSX.Element | null {
    const { languageName, languageLink } = this.props.config;
    const langSwitch = (
      <React.Fragment>
        <a href={languageLink} id='languageSelector'>
          {languageName}
        </a>
      </React.Fragment>
    );
    const ToysrusLanguageSelectorProps = {
      ...this.props,
      languageSwitcher: langSwitch,
    };
    return this.props.renderView(ToysrusLanguageSelectorProps);
  }
}

export default ToysrusLanguageSelector;
